import { render } from "./DrawingPage.vue?vue&type=template&id=d7b52ff6&scoped=true"
import script from "./DrawingPage.vue?vue&type=script&lang=js"
export * from "./DrawingPage.vue?vue&type=script&lang=js"

import "./DrawingPage.vue?vue&type=style&index=0&id=d7b52ff6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b52ff6"]])

export default __exports__